import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import OverviewTab from "./tabs/OverviewTab";
import VisaRequestsTab from "./tabs/VisaRequestsTab";
import JobSeekersTab from "./tabs/JobSeekersTab";
import CompanySubmissionsTab from "./tabs/CompanySubmissionsTab";
import GeneralInterestTab from "./tabs/GeneralInterestTab";

const TABS = [
  { id: "overview", label: "📊 Overview",              collection: null },
  { id: "visa",      label: "🛂 Visa Requests",         collection: "visaRequests" },
  { id: "jobs",      label: "🧰 Job Seekers",           collection: "jobSeekers" },
  { id: "company",   label: "🏢 Company Submissions",   collection: "companySubmissions" },
  { id: "general",   label: "🌏 General Interest",      collection: "generalInterest" },
];

export default function AdminDashboard({ onLogout }) {
  const [tab, setTab] = useState("overview");
  const [msg, setMsg] = useState(null);
  const [newCounts, setNewCounts] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const unsubs = TABS.filter(t => t.collection).map(t =>
      onSnapshot(collection(db, t.collection), snap => {
        const count = snap.docs.filter(d => d.data().status !== "reviewed").length;
        setNewCounts(prev => ({ ...prev, [t.collection]: count }));
      })
    );
    return () => unsubs.forEach(u => u());
  }, []);

  const flash = text => { setMsg({ text, type: "ok" }); setTimeout(() => setMsg(null), 3000); };
  const flashError = text => setMsg({ text, type: "err" });

  const bannerStyle = type => ({
    display: "flex", justifyContent: "space-between", alignItems: "center",
    borderRadius: 10, padding: ".7rem 1.1rem", marginBottom: "1.1rem",
    fontWeight: 700, fontSize: ".87rem",
    ...(type === "ok"
      ? { background: "#e8f5e9", border: "1.5px solid #a5d6a7", color: "#2e7d32" }
      : { background: "#ffebee", border: "1.5px solid #ef9a9a", color: "#c62828" }),
  });

  return (
    <div className="admin-wrap">
      <div className="sidebar">
        <div className="sidebar-hdr">
          <div className="s1">Korea Papua LNG</div>
          <div className="s2">Submissions Manager</div>
        </div>
        {TABS.map(t => (
          <button key={t.id} className={`sb-lnk${tab === t.id ? " on" : ""}`}
            onClick={() => { setTab(t.id); setMsg(null); }}>
            <span>{t.label}</span>
            {t.collection && !!newCounts[t.collection] && (
              <span className="sb-count">{newCounts[t.collection]}</span>
            )}
          </button>
        ))}
        <div style={{ borderTop: "1px solid rgba(255,255,255,.14)", margin: "1rem 0" }}/>
        <button className="sb-lnk" onClick={() => navigate("/")}>🌐 View Website</button>
        <button className="sb-lnk" onClick={async () => { await onLogout(); navigate("/"); }}>🚪 Sign Out</button>
      </div>

      <div className="admin-main">
        {msg && (
          <div style={bannerStyle(msg.type)}>
            <span>{msg.type === "ok" ? "✓" : "✗"} {msg.text}</span>
            {msg.type === "err" && (
              <button onClick={() => setMsg(null)}
                style={{ background: "none", border: "none", cursor: "pointer", color: "#c62828", fontWeight: 900, fontSize: "1rem", lineHeight: 1 }}>
                ×
              </button>
            )}
          </div>
        )}

        {tab === "overview" && <OverviewTab/>}
        {tab === "visa"     && <VisaRequestsTab flash={flash} flashError={flashError}/>}
        {tab === "jobs"     && <JobSeekersTab flash={flash} flashError={flashError}/>}
        {tab === "company"  && <CompanySubmissionsTab flash={flash} flashError={flashError}/>}
        {tab === "general"  && <GeneralInterestTab flash={flash} flashError={flashError}/>}
      </div>
    </div>
  );
}
